ApplicationSerializer = require './application'

App.OrderSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    bonuses:
      deserialize: 'records'
      serialize:   false
    messages:
      deserialize: 'records'
      serialize:   false
    confirmed_by:
      deserialize: 'records'
      serialize:   false
